function SunIcon() {
  return (
    <span className="anticon anticon-sun">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          stroke="Currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M10 15.416a5.417 5.417 0 100-10.833 5.417 5.417 0 000 10.833z"
        />
        <path
          stroke="Currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M15.95 15.95l-.109-.108m0-11.683l.108-.109-.108.109zM4.049 15.95l.109-.108-.109.108zM10 1.734v-.067.067zm0 16.6v-.067.067zM1.733 10h-.067.067zm16.6 0h-.067.067zM4.158 4.16l-.109-.109.109.109z"
        />
      </svg>
    </span>
  );
}

export default SunIcon;
